<p-panel data-tone="surface">
  <ng-template pTemplate="header">
    <h4>
      {{ 'Inventory_Transaction_Title' | translateWF: 'Inventory Transaction' }}
      @if (inventoryTransaction?.id) {
        <div class="transaction-id-wrapper" (click)="copyTransactionId(inventoryTransaction!.id!)" pTooltip="{{ inventoryTransaction!.id }}" tooltipPosition="top">
          <code class="short-id">...{{ inventoryTransaction!.id!.slice(-6) }}</code>
          <i class="pi pi-copy copy-icon"></i>
        </div>
      } @else {
        {{ 'Inventory_Transaction_New' | translateWF: 'New Inventory Transaction' }}
      }
    </h4>
  </ng-template>
  <ng-template pTemplate="icons">
    <p-tag [value]="getStatusLabel()" [severity]="inventoryTransaction?.id ? 'success' : 'warn'"></p-tag>
  </ng-template>
  <p-card>
    <div class="p-fluid col">
      <div class="grid-12 gap-[1rem]">
        <div class="span-3">
          <div class="form-box">
            <label for="fromWarehouse">{{ 'Inventory_Transaction_Coming_From' | translateWF: 'Coming From' }}</label>
            <input class="w-full" type="text" pInputText disabled [value]="getLocationByCode(comingFromLocationCode ?? '')?.name?.en" disabled />
          </div>
        </div>
        <div class="span-3">
          <div class="form-box">
            <label for="toWarehouse">{{ 'Inventory_Transaction_Going_To' | translateWF: 'Going To' }}</label>
            <input class="w-full" type="text" pInputText [value]="getLocationByCode(goingToLocationCode ?? '')?.name?.en" disabled />
          </div>
        </div>
        <div class="span-6">
          @if (!dischargingLotItems) {
            @if (type === 'requisition-details' && !readonly) {
              <div class="field col-12">
                <label for="lotItems">{{ 'Inventory_Transaction_Search_Lot' | translateWF: 'Search Item of Lot' }}</label>
                <p-autoComplete
                  fluid
                  dropdownIcon="pi pi-search"
                  #lotItemSearchRef="cslServerSearch"
                  [cslServerSearch]="fetchLotItems"
                  [suggestions]="lotItemSearchRef.results()"
                  field="fieldToDisplay"
                  [dropdown]="true"
                  [formControl]="lotItemSearch"
                ></p-autoComplete>
              </div>
            } @else if (type === 'transfer-unit-details') {
              <div class="field col-12" *ngIf="allowTransferUnitActions && !readonly">
                <label for="lotItems">{{ 'Inventory_Transaction_Search_Rolls' | translateWF: 'Search Rolls' }}</label>
                <p-autoComplete
                  fluid
                  dropdownIcon="pi pi-search"
                  #rollSearchRef="cslServerSearch"
                  [cslServerSearch]="fetchRolls"
                  [suggestions]="rollSearchRef.results()"
                  [searchOptions]="{ debounceMs: 2000 }"
                  field="number"
                  [dropdown]="true"
                  [formControl]="rollSearch"
                ></p-autoComplete>
              </div>
            }
          }
        </div>
      </div>

      @if (!dischargingLotItems) {
        <div>
          @if (type === 'requisition-details') {
            <div class="col col__12">
              @for (inventoryTransactionNeededElement of inventoryTransactionNeededElements; track $index) {
                <p-panel [toggleable]="true">
                  <ng-template #header>
                    <div class="flex gap-[1rem]">
                      <h4 class="title__row__tag">
                        ({{ inventoryTransactionNeededElement.Item.itemCode }})
                        {{ localHelperService.getLocalizedValue(inventoryTransactionNeededElement.Item.itemDisplayName) }}
                        <p-tag severity="success" [value]="getItemProgress(inventoryTransactionNeededElement)" />
                      </h4>

                      <p class="text-sm row-sm-start-center">
                        <p-tag severity="info" value="{{ inventoryTransactionNeededElement.Provider.name }}" icon="pi pi-building" styleClass="text-xs"></p-tag>

                        <p-tag severity="warn" value="{{ inventoryTransactionNeededElement.LotNumber }}" icon="pi pi-box" styleClass="text-xs"></p-tag>
                      </p>
                    </div>
                  </ng-template>
                  <ng-template #content>
                    <p-card data-variant="compact">
                      <p-table [value]="getLocalLotItems(inventoryTransactionNeededElement)">
                        <ng-template #header>
                          <tr>
                            <th>{{ 'Inventory_Transaction_Action' | translateWF: 'Action' }}</th>
                            <th>{{ 'Inventory_Transaction_Lot_Item_Number' | translateWF: 'Lot Item ID' }}</th>
                            <th>{{ 'Manufacturer_Label_ID' | translateWF: 'Manufacturer Label ID' }}</th>
                            <th>{{ ('Inventory_Transaction_Item_Code' | translate) || 'Item Code' }}</th>
                            <th>{{ 'Inventory_Transaction_Net_Weight' | translateWF: 'Net Weight' }}</th>
                            <th>{{ 'Inventory_Transaction_Gross_Weight' | translateWF: 'Gross Weight' }}</th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-lot let-index="rowIndex">
                          <tr>
                            <td>
                              <p-button
                                pButton
                                pRipple
                                class="p-button-text p-button-danger"
                                icon="pi pi-trash"
                                [disabled]="readonly || !canEdit"
                                [rounded]="true"
                                [outlined]="true"
                                (click)="upsertLotItemKey(lot, inventoryTransaction!)"
                              />
                            </td>
                            <td>{{ lot.number }}</td>
                            <td>{{ lot.providerLabelNumber }}</td>
                            <td>{{ lot.itemCode }}</td>
                            <td>{{ lot.netQuantity | number: '1.2-2' }}</td>
                            <td>{{ lot.grossQuantity | number: '1.2-2' }}</td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                          <tr>
                            <td colspan="4" class="text-right font-bold">{{ 'Inventory_Transaction_Total' | translateWF: 'Total' }}:</td>
                            <td class="font-bold">
                              {{ getTotalNetQuantity(getLocalLotItems(inventoryTransactionNeededElement), 'net') | number: '1.2-2' }}
                            </td>
                            <td class="font-bold">
                              {{ getTotalNetQuantity(getLocalLotItems(inventoryTransactionNeededElement), 'gross') | number: '1.2-2' }}
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </p-card>
                  </ng-template>
                </p-panel>
              }
            </div>
          } @else if (type === 'transfer-unit-details') {
            <p-table [value]="getRolls()">
              <ng-template #header>
                <tr>
                  <th>{{ 'Inventory_Transaction_Action' | translateWF: 'Action' }}</th>
                  <th>{{ 'Inventory_Transaction_Count' | translateWF: 'Count' }}</th>
                  <th>{{ 'Inventory_Transaction_Number' | translateWF: 'Number' }}</th>
                  <th>{{ 'Inventory_Transaction_Asset_Id' | translateWF: 'Asset ID' }}</th>
                  <th>{{ 'Inventory_Transaction_Weight' | translateWF: 'Weight' }}</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-roll let-index="rowIndex">
                <tr>
                  <!-- Received status: show a button if no warehouse is set -->
                  <td>
                    <p-button
                      *ngIf="!readonly"
                      [disabled]="!allowTransferUnitActions || !canEdit"
                      pButton
                      pRipple
                      class="p-button-text p-button-danger"
                      icon="pi pi-trash"
                      [rounded]="true"
                      [outlined]="true"
                      (click)="addRollToTransaction(roll, false)"
                    />
                  </td>
                  <td>{{ index + 1 }}</td>
                  <td>{{ roll.number }}</td>
                  <td>{{ roll.assetId }}</td>
                  <td>{{ roll.netQuantity | number: '1.2-2' }} lbs</td>
                </tr>
              </ng-template>
              <ng-template #footer>
                <tr>
                  <td colspan="4" class="text-right">
                    <strong>{{ 'Inventory_Transaction_Total' | translateWF: 'Total' }}:</strong>
                  </td>
                  <td>{{ getTotalWeight() | number: '1.2-2' }} lbs</td>
                </tr>
              </ng-template>
            </p-table>
          }
        </div>
      } @else {
        <ng-container *ngIf="canEdit">
          <h4>{{ 'Common_Filters' | translateWF: 'Filters' }}</h4>
          <div class="flex gap-[1rem]">
            <p-multiselect
              *ngIf="!isConsignment"
              [options]="getDistictInvoiceOptions()"
              [formControl]="selectedInvoices"
              optionLabel="invoiceNumber"
              placeholder="{{ 'Inventory_Transaction_Select_Invoice' | translateWF: 'Select Invoice' }}"
            />

            <p-multiselect
              [options]="getItemOptions()"
              optionLabel="itemCode"
              [formControl]="selectedItemCodes"
              placeholder="{{ ('Inventory_Transaction_Item_Code' | translate) || 'Item Code' }}"
            />
            <p-inputgroup class="w-fit-content">
              <input pInputText type="text" placeholder="{{ 'Common_Search' | translateWF: 'Search' }}" [formControl]="searchBy" />
              <p-inputgroup-addon>
                <p-button icon="pi pi-search" severity="secondary" variant="text" />
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>
        </ng-container>

        <p-progressBar [value]="getProgress()" [style]="{ height: '24px' }"></p-progressBar>

        <p-table [value]="getLotItems()">
          <ng-template #header>
            <tr class="primary__header">
              <th>{{ 'Common_Received' | translateWF: 'Received' }}</th>
              <th *ngIf="canEdit">{{ 'Common_Print_Label' | translateWF: 'Print Label' }}</th>
              <th>{{ 'Inventory_Transaction_Lot_Item_Number' | translateWF: 'Lot Item ID' }}</th>
              <th>{{ 'Manufacturer_Label_ID' | translateWF: 'Manufacturer Label ID' }}</th>
              <th>{{ 'Manufacturer' | translateWF: 'Manufacturer' }}</th>
              <th>{{ 'Manufacturer_Lot_Number' | translateWF: 'Manufacturer Lot Number' }}</th>
              <th>{{ 'Provider' | translateWF: 'Provider' }}</th>
              <th>{{ 'Common_Invoice' | translateWF: 'Invoice' }}</th>
              <th>{{ 'Inventory_Transaction_Item_Code' | translateWF: 'Item Code' }}</th>
              <th>{{ 'Inventory_Transaction_Description' | translateWF: 'Description' }}</th>
              <th>{{ 'Inventory_Transaction_UOM' | translateWF: 'Unit of Measure' }}</th>
              <th>{{ 'Inventory_Transaction_Net_Weight' | translateWF: 'Net Weight' }}</th>
              <th>{{ 'Inventory_Transaction_Gross_Weight' | translateWF: 'Gross Weight' }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-lot>
            <tr>
              <td>
                @if (isShipmentReadyToUnload) {
                  <ng-container *ngIf="isLotItemLoading(lot); else loaded">
                    <p-progressSpinner></p-progressSpinner>
                  </ng-container>
                  <ng-template #loaded>
                    <ng-container *ngIf="!isLotItemKeyReceived(lot, inventoryTransaction!); else notReceived">
                      <p-button icon="pi pi-plus" [rounded]="true" (click)="upsertLotItemKey(lot, inventoryTransaction!)" severity="warn" [disabled]="!canEdit" />
                    </ng-container>
                    <ng-template #notReceived>
                      <p-button icon="pi pi-check" [rounded]="true" />
                    </ng-template>
                  </ng-template>
                }
              </td>
              <ng-container *ngIf="canEdit">
                <td>
                  <p-button icon="pi pi-print" [rounded]="true" [outlined]="true" (click)="getLotItemLabel(lot)" *ngIf="isLotItemKeyReceived(lot, inventoryTransaction!)" />
                </td>
              </ng-container>
              <td>{{ lot.number }}</td>
              <td>{{ lot.providerLabelNumber }}</td>
              <td>{{ lot.manufacturer?.name }}</td>
              <td>{{ lot.providerLotId }}</td>
              <td>{{ lot.provider?.name }}</td>
              <td>{{ lot?.invoice?.invoiceNumber }}</td>
              <td>{{ lot.itemCode }}</td>
              <td>{{ lot.item ? localHelperService.getLocalizedValue(lot.item.itemDescription) : '' }}</td>
              <td>{{ lot.item ? unitOfMeasure[lot.item.unitOfMeasure] : '' }}</td>
              <td>{{ lot.originalNetQuantity | number: '1.2-2' }}</td>
              <td>{{ lot.originalGrossQuantity | number: '1.2-2' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td colspan="11" class="text-right font-bold">{{ 'Inventory_Transaction_Total' | translateWF: 'Total' }}:</td>
              <td class="font-bold">
                {{ getTotalNetQuantity(getLotItems(), 'net') | number: '1.2-2' }}
              </td>
              <td class="font-bold">
                {{ getTotalNetQuantity(getLotItems(), 'gross') | number: '1.2-2' }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
  </p-card>
</p-panel>
